/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleBigQueryGa4PseudonymousUsersReportDailyData } from './GoogleBigQueryGa4PseudonymousUsersReportDailyData';
import {
    GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSON,
    GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSONTyped,
    GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSON,
    GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSONTyped,
} from './GoogleBigQueryGa4PseudonymousUsersReportDailyData';
import type { GoogleBigQueryGa4PseudonymousUsersReportTotalsData } from './GoogleBigQueryGa4PseudonymousUsersReportTotalsData';
import {
    GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSON,
    GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSONTyped,
    GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSON,
    GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSONTyped,
} from './GoogleBigQueryGa4PseudonymousUsersReportTotalsData';

/**
 * 
 * @export
 * @interface GoogleBigQueryGa4PseudonymousUsersReportData
 */
export interface GoogleBigQueryGa4PseudonymousUsersReportData {
    /**
     * 
     * @type {GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    status?: GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum;
    /**
     * 
     * @type {GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    reason?: GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    requestedSince?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    requestedUntil?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    coverageSince?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    coverageUntil?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    latestCompletedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    propertyTimezone?: string | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    missingDates?: Array<Date>;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4PseudonymousUsersReportDailyData>}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    daily?: Array<GoogleBigQueryGa4PseudonymousUsersReportDailyData>;
    /**
     * 
     * @type {GoogleBigQueryGa4PseudonymousUsersReportTotalsData}
     * @memberof GoogleBigQueryGa4PseudonymousUsersReportData
     */
    totals?: GoogleBigQueryGa4PseudonymousUsersReportTotalsData | null;
}


/**
 * @export
 */
export const GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum = {
    Available: 'AVAILABLE',
    Partial: 'PARTIAL',
    Unavailable: 'UNAVAILABLE'
} as const;
export type GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum = typeof GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum[keyof typeof GoogleBigQueryGa4PseudonymousUsersReportDataStatusEnum];

/**
 * @export
 */
export const GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum = {
    ExportNotAvailable: 'EXPORT_NOT_AVAILABLE',
    TimezoneNotConfigured: 'TIMEZONE_NOT_CONFIGURED',
    NoSuccessfulPublication: 'NO_SUCCESSFUL_PUBLICATION',
    NoCoverageInRequestedRange: 'NO_COVERAGE_IN_REQUESTED_RANGE',
    RequestHasNoCompletedDates: 'REQUEST_HAS_NO_COMPLETED_DATES'
} as const;
export type GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum = typeof GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum[keyof typeof GoogleBigQueryGa4PseudonymousUsersReportDataReasonEnum];


/**
 * Check if a given object implements the GoogleBigQueryGa4PseudonymousUsersReportData interface.
 */
export function instanceOfGoogleBigQueryGa4PseudonymousUsersReportData(value: object): value is GoogleBigQueryGa4PseudonymousUsersReportData {
    return true;
}

export function GoogleBigQueryGa4PseudonymousUsersReportDataFromJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportData {
    return GoogleBigQueryGa4PseudonymousUsersReportDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4PseudonymousUsersReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'reason': json['reason'] === undefined ? undefined : json['reason'] === null ? null : json['reason'],
        'requestedSince': json['requestedSince'] == null ? undefined : (new Date(json['requestedSince'])),
        'requestedUntil': json['requestedUntil'] == null ? undefined : (new Date(json['requestedUntil'])),
        'coverageSince': json['coverageSince'] === undefined ? undefined : json['coverageSince'] === null ? null : (new Date(json['coverageSince'])),
        'coverageUntil': json['coverageUntil'] === undefined ? undefined : json['coverageUntil'] === null ? null : (new Date(json['coverageUntil'])),
        'latestCompletedDate': json['latestCompletedDate'] === undefined ? undefined : json['latestCompletedDate'] === null ? null : (new Date(json['latestCompletedDate'])),
        'propertyTimezone': json['propertyTimezone'] === undefined ? undefined : json['propertyTimezone'] === null ? null : json['propertyTimezone'],
        'missingDates': json['missingDates'] == null ? undefined : json['missingDates'],
        'daily': json['daily'] == null ? undefined : ((json['daily'] as Array<any>).map(GoogleBigQueryGa4PseudonymousUsersReportDailyDataFromJSON)),
        'totals': json['totals'] === undefined ? undefined : json['totals'] === null ? null : GoogleBigQueryGa4PseudonymousUsersReportTotalsDataFromJSON(json['totals']),
    };
}

export function GoogleBigQueryGa4PseudonymousUsersReportDataToJSON(json: any): GoogleBigQueryGa4PseudonymousUsersReportData {
    return GoogleBigQueryGa4PseudonymousUsersReportDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4PseudonymousUsersReportDataToJSONTyped(value?: GoogleBigQueryGa4PseudonymousUsersReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reason': value['reason'],
        'requestedSince': value['requestedSince'] == null ? value['requestedSince'] : value['requestedSince'].toISOString().substring(0,10),
        'requestedUntil': value['requestedUntil'] == null ? value['requestedUntil'] : value['requestedUntil'].toISOString().substring(0,10),
        'coverageSince': value['coverageSince'] == null ? value['coverageSince'] : value['coverageSince'].toISOString().substring(0,10),
        'coverageUntil': value['coverageUntil'] == null ? value['coverageUntil'] : value['coverageUntil'].toISOString().substring(0,10),
        'latestCompletedDate': value['latestCompletedDate'] == null ? value['latestCompletedDate'] : value['latestCompletedDate'].toISOString().substring(0,10),
        'propertyTimezone': value['propertyTimezone'],
        'missingDates': value['missingDates'],
        'daily': value['daily'] == null ? undefined : ((value['daily'] as Array<any>).map(GoogleBigQueryGa4PseudonymousUsersReportDailyDataToJSON)),
        'totals': GoogleBigQueryGa4PseudonymousUsersReportTotalsDataToJSON(value['totals']),
    };
}

